import styled from "styled-components";

export const PatientSelection = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
